import { STAGES } from "@/data/demo";
import { cn } from "@/lib/utils";

export const initials = (name) =>
  name.replace(/^Adv\.\s*/, "").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

const AVATAR_TONES = ["bg-navy text-white", "bg-amber-100 text-amber-800", "bg-slate-200 text-slate-700", "bg-emerald-100 text-emerald-800"];

export const Avatar = ({ name, size = "md", className }) => {
  const tone = AVATAR_TONES[name.length % AVATAR_TONES.length];
  const sz = size === "lg" ? "h-16 w-16 text-xl" : size === "sm" ? "h-8 w-8 text-xs" : "h-11 w-11 text-sm";
  return (
    <div className={cn("shrink-0 rounded-full grid place-items-center font-semibold font-heading", tone, sz, className)}>
      {initials(name)}
    </div>
  );
};

const STAGE_TONE = (i) =>
  i <= 1 ? "bg-sky-50 text-sky-700 border-sky-200"
    : i === 2 ? "bg-orange-50 text-orange-700 border-orange-200"
      : i === 3 ? "bg-amber-50 text-amber-800 border-amber-300"
        : i <= 6 ? "bg-indigo-50 text-indigo-700 border-indigo-200"
          : "bg-emerald-50 text-emerald-700 border-emerald-200";

export const StageBadge = ({ stage, testId = "case-stage-badge" }) => (
  <span data-testid={testId} className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold whitespace-nowrap", STAGE_TONE(stage))}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {STAGES[stage].title}
  </span>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-navy">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Btn = ({ variant = "primary", className, children, ...props }) => {
  const styles = {
    primary: "bg-navy text-white hover:bg-navy-light",
    gold: "bg-gold text-white hover:bg-gold-hover",
    outline: "border border-slate-200 bg-white text-navy hover:border-slate-300 hover:bg-slate-50",
    ghost: "text-slate-600 hover:bg-slate-100",
    danger: "border border-red-200 bg-white text-red-600 hover:bg-red-50",
  };
  return (
    <button
      className={cn("inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition-[background-color,border-color,transform] duration-200 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400", styles[variant], className)}
      {...props}
    >
      {children}
    </button>
  );
};

export const Card = ({ className, children, ...props }) => (
  <div className={cn("rounded-2xl border border-slate-200/80 bg-white shadow-soft", className)} {...props}>
    {children}
  </div>
);
